"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uxcore = require("@ux/uxcore2");

var _CartContent = _interopRequireDefault(require("./CartContent"));

var _reactIntl = require("react-intl");

var _namespaceComponent = require("@ux/namespace-component");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Cart =
/*#__PURE__*/
function (_NamespaceConsumer) {
  _inherits(Cart, _NamespaceConsumer);

  function Cart(props) {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Cart);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Cart)).call.apply(_getPrototypeOf2, [this, props].concat(args)));
    _this.onChangeTimeout = null;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Cart, [{
    key: "handleChange",
    value: function handleChange() {
      this.props.onChange && this.props.onChange();
      this.setState({
        placeholders: 0
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClose = _this$props.onClose,
          onContinue = _this$props.onContinue,
          basket = _this$props.basket,
          loading = _this$props.loading,
          currency = _this$props.currency,
          market = _this$props.market,
          language = _this$props.language;
      var handleChange = this.handleChange;
      var isBasketEmpty = Boolean(!(basket && basket.items && basket.items.length));
      return _react["default"].createElement("div", {
        className: this.namespace('hc-cart')
      }, _react["default"].createElement("div", {
        className: this.namespace('hc-cart-header bg-dark')
      }, _react["default"].createElement("span", {
        className: this.namespace('ms3')
      }, _react["default"].createElement("strong", null, isBasketEmpty ? _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Shared:UtilityBar:HeaderCart:basket"
      }) : _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Shared:UtilityBar:HeaderCart:basketCount",
        values: {
          count: basket.items.length
        }
      }))), _react["default"].createElement(_uxcore.Button, {
        "data-eid": "gce.header_cart.sales_header.close_x.click",
        design: "tertiary",
        onClick: onClose
      }, _react["default"].createElement(_uxcore.Icon, {
        name: "x",
        color: "white"
      }))), _react["default"].createElement(_CartContent["default"], {
        key: basket.requestKey,
        basket: basket,
        loading: loading,
        onChange: handleChange,
        currency: currency,
        market: market,
        language: language
      }), !isBasketEmpty && _react["default"].createElement("div", {
        className: this.namespace('hc-cart-continue')
      }, _react["default"].createElement(_uxcore.Button, {
        "data-eid": "gce.header_cart.sales_header.continue_button.click",
        className: this.namespace('m-b-1'),
        design: "primary",
        onClick: onContinue
      }, _react["default"].createElement(_uxcore.Icon, {
        name: "cart",
        color: "white"
      }), _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Shared:UtilityBar:HeaderCart:continueToCart"
      })), _react["default"].createElement(_uxcore.Button, {
        "data-eid": "gce.header_cart.sales_header.close_button.click",
        design: "default",
        onClick: onClose
      }, _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Shared:UtilityBar:HeaderCart:continueShopping"
      }))));
    }
  }]);

  return Cart;
}(_namespaceComponent.NamespaceConsumer);

Cart.propTypes = {
  currency: _propTypes["default"].string.isRequired,
  market: _propTypes["default"].string.isRequired,
  basket: _propTypes["default"].object,
  onChange: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onContinue: _propTypes["default"].func,
  requestKey: _propTypes["default"].number,
  loading: _propTypes["default"].bool,
  language: _propTypes["default"].object.isRequired
};
var _default = Cart;
exports["default"] = _default;